import React from "react";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import styles from "./ContentAutocompleteSearch.module.css";
import ContentToLink from "../content-to-link/ContentToLink";
import { setDisableKeyEvents } from "../../../../../../../../../common/slice";
import { CustomTextField } from "../../../../../../../../../common/components";

const ContentAutocompleteSearch = ({
	disabled = false,
	contents,
	emptyStateLabel,
	error,
	helperText,
	informationText = "",
	inputValue,
	isLoading,
	label = "",
	listBoxClassName = "",
	resetKey,
	selectedClassName = "",
	selectedItemClassName = "",
	onCheckSelectedContent = null,
	onHideResult = null,
	onReset,
	onSearch,
	onSelect,
}) => {
	const dispatch = useDispatch();
	return (
		<Autocomplete
			key={resetKey}
			clearOnBlur
			fullWidth
			disabled={disabled}
			disablePortal={false}
			filterOptions={(options) => options}
			getOptionLabel={(option) => option.content}
			inputValue={inputValue || ""}
			ListboxProps={{ className: listBoxClassName }}
			loading={isLoading}
			noOptionsText={emptyStateLabel}
			options={contents || []}
			renderInput={(params) => (
				<CustomTextField
					{...params}
					error={error}
					helperText={error && helperText}
					InputLabelProps={{ className: styles.labelProps }}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{isLoading ? <CircularProgress size={20} /> : null}
								{params.InputProps.endAdornment}
							</>
						),
						className: styles.props,
					}}
					label={label}
					variant="outlined"
					onBlur={() => dispatch(setDisableKeyEvents(false))}
					onFocus={() => dispatch(setDisableKeyEvents(true))}
				/>
			)}
			renderOption={(props, option) => (
				<>
					{(!onHideResult || (typeof onHideResult === "function" && onHideResult(option))) && (
						<div
							{...props}
							className={`${styles.option} ${
								typeof onCheckSelectedContent === "function" &&
								onCheckSelectedContent(option) &&
								selectedClassName
							}`}
						>
							<ContentToLink
								className={
									typeof onCheckSelectedContent === "function" &&
									onCheckSelectedContent(option) &&
									selectedItemClassName
								}
								content={option}
								informationText={informationText}
								onCheckSelectedContent={onCheckSelectedContent}
							/>
						</div>
					)}
				</>
			)}
			size="small"
			onChange={(e, value, reason) => {
				if (reason === "clear") {
					onReset(value);
					return;
				}
				onSelect(value);
			}}
			onInputChange={(e, value, reason) => {
				if (reason === "clear") {
					onReset(value);
					return;
				}
				onSearch(value);
			}}
		/>
	);
};
export default ContentAutocompleteSearch;
